import { useState, useRef, useEffect } from "react";
import { useLanguage } from "../context/LanguageContext";
import { ChevronDown } from "lucide-react";

export const LanguageSelector = ({ isScrolled = false }) => {
  const { language, changeLanguage, languages, currentLanguage } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Zatvori dropdown kad se klikne izvan
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLanguageSelect = (langCode) => {
    changeLanguage(langCode);
    setIsOpen(false);
  };

  return (
    <div className="relative" ref={dropdownRef}>
      {/* Trigger Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`flex items-center gap-2 px-3 py-2 rounded-lg transition-all duration-300 ${
          isScrolled
            ? "bg-[#f1f5f9] hover:bg-[#e2e8f0] text-[#0F172A]"
            : "bg-white/20 hover:bg-white/30 text-white backdrop-blur-sm"
        }`}
        data-testid="language-selector-trigger"
        aria-expanded={isOpen}
        aria-haspopup="listbox"
      >
        <span className="text-lg leading-none">{currentLanguage.flag}</span>
        <span className="text-sm font-medium hidden sm:inline">
          {currentLanguage.code.toUpperCase()}
        </span>
        <ChevronDown
          size={16}
          className={`transition-transform duration-200 ${isOpen ? "rotate-180" : ""}`}
        />
      </button>

      {/* Dropdown Menu */}
      {isOpen && (
        <div
          className="absolute right-0 mt-2 py-2 w-48 bg-white rounded-xl shadow-xl border border-[#e2e8f0] z-50 animate-fadeIn"
          role="listbox"
          data-testid="language-dropdown"
        >
          {languages.map((lang) => (
            <button
              key={lang.code}
              onClick={() => handleLanguageSelect(lang.code)}
              className={`w-full flex items-center gap-3 px-4 py-2.5 text-left hover:bg-[#f1f5f9] transition-colors duration-150 ${
                language === lang.code ? "bg-[#f1f5f9]" : ""
              }`}
              role="option"
              aria-selected={language === lang.code}
              data-testid={`language-option-${lang.code}`}
            >
              <span className="text-xl leading-none">{lang.flag}</span>
              <span className="text-sm font-medium text-[#0F172A]">
                {lang.name}
              </span>
              {language === lang.code && (
                <span className="ml-auto text-[#004E64]">✓</span>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
